export default __webpack_public_path__ + "static/media/vimeo_yds_intro.a6477808.jpg";